import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/store/AppContext";
import { LiveProvider } from "@/store/LiveContext";
import RequireAuth from "@/components/RequireAuth";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import EnterpriseCommandCenter from "@/pages/EnterpriseCommandCenter";
import ProcessMimic from "@/pages/ProcessMimic";
import UtilityEconomics from "@/pages/UtilityEconomics";
import ProductEconomics from "@/pages/ProductEconomics";
import EnergyFlow from "@/pages/EnergyFlow";
import TwinDetail from "@/pages/TwinDetail";
import TwinExplorer from "@/pages/TwinExplorer";
import Sustainability from "@/pages/Sustainability";
import AIOperations from "@/pages/AIOperations";
import SimulationStudio from "@/pages/SimulationStudio";
import ShadowComparison from "@/pages/ShadowComparison";
import HistoryReplay from "@/pages/HistoryReplay";
import AssetHealth from "@/pages/AssetHealth";
import OperatorTraining from "@/pages/OperatorTraining";
import DBInspector from "@/pages/DBInspector";

// Providers live inside the guard so the live WebSocket only connects once a
// token exists (it is passed to the backend as ?token=).
function ProtectedApp() {
  return (
    <RequireAuth>
      <AppProvider>
        <LiveProvider>
          <AppLayout />
        </LiveProvider>
      </AppProvider>
    </RequireAuth>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedApp />}>
            <Route path="/" element={<EnterpriseCommandCenter />} />
            <Route path="/process" element={<ProcessMimic />} />
            <Route path="/economics" element={<UtilityEconomics />} />
            <Route path="/products" element={<ProductEconomics />} />
            <Route path="/energy" element={<EnergyFlow />} />
            <Route path="/twin/:id" element={<TwinDetail />} />
            <Route path="/twins" element={<TwinExplorer />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/ai" element={<AIOperations />} />
            <Route path="/simulation" element={<SimulationStudio />} />
            <Route path="/shadow" element={<ShadowComparison />} />
            <Route path="/replay" element={<HistoryReplay />} />
            <Route path="/assets" element={<AssetHealth />} />
            <Route path="/training" element={<OperatorTraining />} />
            <Route path="/db" element={<DBInspector />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
